import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaPhone,
  FaEnvelope,
  FaClock,
} from 'react-icons/fa';
import './Footer.css';

import logo from '../../assets/images/logo.png'; // adjust path if needed

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">

        {/* TOP CONTACT STRIP */}
        <div className="f-contact mar-bottom-50">
          <div className="row">

            <div className="col-lg-4 col-md-12">
              <div className="f-contact-inner">
                <div className="contact-icon">
                  <FaPhone />
                </div>
                <div className="contact-title">
                  <span className="white">+123-456-79459</span>
                  <span className="white">Have a question? call us now</span>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12">
              <div className="f-contact-inner">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div className="contact-title">
                  <span className="white">
                    <a href="mailto:info@example.com">info@example.com</a>
                  </span>
                  <span className="white">Need support? Drop us an email</span>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12">
              <div className="f-contact-inner">
                <div className="contact-icon">
                  <FaClock />
                </div>
                <div className="contact-title">
                  <span className="white">323 Wintergreen, NJ 07631, USA</span>
                  <span className="white">You can find here</span>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* FOOTER CONTENT */}
        <div className="footer-content">
          <div className="lower-footer pad-bottom-50">
            <div className="row">

              {/* ABOUT */}
              <div className="col-lg-5 col-md-12">
                <div className="footer-contact mar-right-15">
                  <div className="footer-logo text-center mar-bottom-15">
                    <img src={logo} alt="Hospital Logo" />
                  </div>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    <br /><br />
                    We are among the most qualified implant providers with over
                    30 years of quality training and experience.
                  </p>
                </div>
              </div>

              {/* DEPARTMENTS */}
              <div className="col-lg-2 col-md-4">
                <div className="departments">
                  <h3>Departments</h3>
                  <ul>
                    <li><Link to="/departments/radiology">Radiology</Link></li>
                    <li><Link to="/departments/pedodontics">Pedodontics</Link></li>
                    <li><Link to="/departments/dental">Dental Implants</Link></li>
                    <li><Link to="/departments/oral">Oral & Maxillofacial</Link></li>
                  </ul>
                </div>
              </div>

              {/* FACILITIES */}
              <div className="col-lg-2 col-md-3">
                <div className="facility">
                  <h3>Facilities</h3>
                  <ul>
                    <li><Link to="/facilities/blood-bank">Blood Bank</Link></li>
                    <li><Link to="/facilities/icu">Intensive Care Unit</Link></li>
                    <li><Link to="/facilities/lab">Laboratories</Link></li>
                    <li><Link to="/facilities/dental">Tooth Care</Link></li>
                    <li><Link to="/facilities/cleaning">Scale and Clean</Link></li>
                  </ul>
                </div>
              </div>

              {/* WORK TIME */}
              <div className="col-lg-3 col-md-5">
                <div className="work-time">
                  <h3>Work Time</h3>
                  <ul>
                    <li>Monday <span>10 AM - 3 PM</span></li>
                    <li>Tuesday <span>11 AM - 2 PM</span></li>
                    <li>Wednesday <span>10 AM - 3:30 PM</span></li>
                    <li>Thursday <span>9 AM - 2 PM</span></li>
                  </ul>
                </div>
              </div>

            </div>
          </div>

          {/* COPYRIGHT */}
          <div className="copyright">
            <div className="container">
              <p>
                © {new Date().getFullYear()} New Jeevan Deep. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>

      </div>
    </footer>
    
  );
  
};
const BackToTop = () => {
  return(
  <div  id="back-to-top">
       <a href="javascript:void(0)"></a>↑
    </div>
    );
}
const SearchBar = () => {
  return (
   <div id="search1">
      <button type="button" className="close">×</button>
      <form>
        <input type="search" value="" placeholder="type keyword(s) here" />
        <button type="submit" className="btn btn-primary">Search</button>
      </form>
    </div>
  );
} 

export { BackToTop, SearchBar };
  
export default Footer;

